import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const proofpointThreatResponse = defineConnector({
  identifier: "proofpointThreatResponse",
  name: "Proofpoint Threat Response",
  tagLine: "Automated threat response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ domain }) => domainToRegex(domain),
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Proofpoint Threat Response (TRAP) console, go to **Sources → API Key** to generate or retrieve your API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          required: true,
          placeholder: "trap.example.com",
          helperText: "Your Proofpoint TRAP domain.",
          target: { kind: "configuration", field: "domain" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/incidents?limit=1`,
  },
});
